module.exports = __webpack_public_path__ + "static/media/pinch04.1c5b9e5d.webp";